



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PaymentOrderFeeState from '@/models/Accounts/Shared/PaymentOrders/PaymentOrderFeeState';

@Component({ name: 'PaymentOrderFeeState' })
export default class extends SaascadaVue {

    @Prop({ required: true })
    status: PaymentOrderFeeState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.status) {
            case PaymentOrderFeeState.FeePending:
                color = "warning--text";
                break;
            case PaymentOrderFeeState.FeePaid:
                color = "success--text";
                break;
            case PaymentOrderFeeState.FeeFailed:
                color = "error--text";
                break;
            default:
                color = "grey-text";
                break;
        }
        return color;
    }

}
